@if (_loader.value$|async) {
    <mat-progress-bar class="position-progress-bar" mode="determinate"
                      [value]="_loader.value$|async" color="accent">
    </mat-progress-bar>
}
<router-outlet>
    @if (_loader.value$|async) {
        <div class="wrapper">
            <mat-progress-spinner [value]="_loader.value$|async" [diameter]="150" [strokeWidth]="13"
                                  [mode]="'indeterminate'" color="accent">
            </mat-progress-spinner>
        </div>
    }
</router-outlet>
